import { BrowserComponent } from '../app';
import { easeInOutQuad } from '../tools/transition';
import { Component } from './component';
import { debug } from 'console';

/**
 * Toggle scroll lock for body element
 *
 * @class
 * @version					1.0
 * @css							scroll-lock.scss
 * @require					getScrollPosition
 * @changelog
 * 26.06.2019 Support custom properties polyfill
 * 20.06.2019 Add
 */

interface IScrollTo {
	time: number;
	offset?: number;
	callbackAfter?: Function;
	targetElement?: HTMLElement,
	positionY?: number;
	scrollingElement?: HTMLElement;
}

interface IScrollInfo {
	top: number;
	bottom: number;
	center: number;
	speed: number;
	direction: 'up' | 'down';
}

export class Scroll extends Component {
	public info: IScrollInfo;

	private isActive = false;
	public scrollingElement: HTMLElement;

	constructor() {
		super();
	}

	onInit() {
		this.scrollingElement = document.scrollingElement as HTMLElement || document.documentElement;

		this.info = {
			bottom: null,
			top: null,
			center: null,
			speed: null,
			direction: null,
		}
	}

	onScroll() {
		this.updateInfo();
	}

	onResize() {
		this.updateInfo();
	}

	private updateInfo() {
		let { top, center = 0, bottom, direction, speed } = this.info;
		let lastCenter = center;

		/* Set variables */
		top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		center = top + BrowserComponent.height / 2;
		bottom = top + BrowserComponent.height;
		speed = Math.abs(lastCenter - center);

		/* Check scroll direction */
		if (center > lastCenter) {
			direction = "down";
		}
		else {
			direction = "up";
		}

		this.info = {
			top,
			center,
			bottom,
			direction,
			speed
		};
	}

	/**
	* Smooth scroll page to position value or HTML element.
	* @parameter IScrollTo
	*/
	public to(params: IScrollTo) {
		if (this.isActive) {
			return;
		}
		this.isActive = true;

		const { targetElement, time, callbackAfter, offset = 0, scrollingElement = this.scrollingElement } = params;
		const start = scrollingElement.scrollTop;

		let change = targetElement.offsetTop - start - offset;
		let increment = 20;
		let currentTime = 0;

		// if (change - start > BrowserComponent.documentHeight - BrowserComponent.height) {
		// 	change = BrowserComponent.documentHeight - BrowserComponent.height;
		// }

		const animateScroll = () => {
			currentTime += increment;

			const val = easeInOutQuad(currentTime, start, change, time);

			scrollingElement.scrollTop = val;

			if (currentTime < time) {
				setTimeout(animateScroll, increment);
			} else {
				this.isActive = false;

				if (callbackAfter) {
					callbackAfter();
				}
			}
		};

		animateScroll();
	}
}